import { EventHandler } from './../types';
import { event } from './../helpers';

const TIMINGS: EventHandler[] = [
  event(
    'GAME_READY',
    ({ timing }) => timing('ready', Math.round(window.performance.now())),
  ),
];

export default TIMINGS;
